module.exports = __webpack_public_path__ + "static/img/20230106_03.32a068c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230106_03.png
// module id = mSr+
// module chunks = 0